import CompanyPage from './classes/company-page';

(function(window) {
  class Restaurants extends CompanyPage {
    constructor(window) {
      super();
      const DOCUMENT = window.document;

      this.startFluxogram();
      this.createVideoSection();
    }
  }

  const restaurants = new Restaurants(window);
})(window);
